export default "__VITE_ASSET__wMAhtcMG__"